import {
  UserDriverListItem,
  UserDriverListItemTaxiAssociation,
} from "../../../../../common/services/user/driver/list/user-driver-list";
import AddressType from "../../../../../common/types/address-type";
import UserStatus from "../../../../../common/types/user-status";
import phoneNumberService from "../../../../../common/utils/phone-number/phone-number.service";
import DriverListingItem from "./types/driver-listing-item";

const createPhoneNumbers = (
  listItem: UserDriverListItem,
): DriverListingItem["phoneNumbers"] => {
  const phoneNumbers: DriverListingItem["phoneNumbers"] = [
    phoneNumberService.getLabel(listItem.phoneNumber),
  ];

  if (listItem.alternativePhoneNumber) {
    phoneNumbers.push(
      phoneNumberService.getLabel(listItem.alternativePhoneNumber),
    );
  }

  return phoneNumbers;
};

const createFleetPartners = (
  listItemTaxiAssociations: UserDriverListItemTaxiAssociation[],
): string[] => {
  const fleetPartners: string[] = [];

  listItemTaxiAssociations.forEach((association) => {
    if (!association.fleetPartner) {
      return;
    }

    fleetPartners.push(association.fleetPartner.name);
  });

  return fleetPartners;
};

const createListingItem = (listItem: UserDriverListItem): DriverListingItem => {
  const startingAddress = listItem.addresses.find(
    (address) => address.type === AddressType.STARTING,
  );

  const fleetPartners: string[] = createFleetPartners(
    listItem.taxiAssociations,
  );

  const taxiCorporations = listItem.taxiAssociations.map(
    (taxiAssociation) => taxiAssociation.taxiCorporation.displayName,
  );

  const phoneNumbers = createPhoneNumbers(listItem);

  return {
    uuid: listItem.uuid,
    firstName: listItem.firstName,
    lastName: listItem.lastName,
    startingAddress:
      startingAddress?.town && startingAddress.zipCode
        ? `${startingAddress.town} ${startingAddress.zipCode}`
        : "",
    taxiCorporations,
    phoneNumbers,
    vehicle: {
      make: listItem.vehicle.make,
      model: listItem.vehicle.model,
      age: listItem.vehicle.productionYear
        ? new Date().getFullYear() - listItem.vehicle.productionYear
        : null,
      ownership: listItem.vehicle.ownership,
    },
    fleetPartners,
    createdByName: listItem.createdByName,
    creationDate: listItem.creationDate,
    modificationDate: listItem.modificationDate,
    modifiedByName: listItem.modifiedByName,
    lastPlanEntryEndTime: listItem.lastPlanEntryEndTime,
    isCandidatureActive: listItem.isCandidaturePending,
    status: !listItem.removalDate ? UserStatus.ACTIVE : UserStatus.DELETED,
  };
};

const createListingItems = (
  listItems: UserDriverListItem[],
): DriverListingItem[] => {
  return listItems.map(createListingItem);
};

const driverListingItemFactory = {
  createListingItems,
};

export default driverListingItemFactory;
